import angular from 'angular';
import catalogModule from '../catalogModule';

function itemCardController($log, $scope, catalogConstants) {
  'ngInject';

  $scope.hasSecondaryInfo = () => {
    return $scope.isCreatorNameShown() || ($scope.item.unitsAvailableForConsumption > 0 && false);
  };

  $scope.isCreatorNameShown = () => {
    return (
      $scope.item &&
      $scope.item.creatorTargetId !== catalogConstants.robloxSystemUserId &&
      $scope.item.creatorName &&
      !$scope.hideCreatorName
    );
  };

  $scope.isItemThumbnailLoading = () => {
    if ($scope.item.itemType === catalogConstants.itemTypes.bundle) {
      return !$scope.layout.isBundleThumbnailLoaded;
    }
    return !$scope.layout.isAssetThumbnailLoaded;
  };

  $scope.isItemThumbnailAvailable = () => {
    return $scope.item.thumbnail && $scope.item.thumbnail.imageUrl;
  };

  $scope.shouldShowPremiumIcon = () => {
    return (
      $scope.library.isPremiumIconOnItemTilesEnabled === true &&
      $scope.item.premiumPricing !== undefined
    );
  };

  $scope.getDisplayPrice = () => {
    if ($scope.library.isPremiumPriceOnItemTilesEnabled && $scope.item.premiumPricing) {
      return $scope.item.premiumPricing.premiumPriceInRobux;
    }

    if ($scope.item.lowestPrice) {
      return $scope.item.lowestPrice;
    }

    return $scope.item.price;
  };

  $scope.clickItemCard = e => {
    if (!$scope.item.detailsUrl) {
      e.preventDefault();
    }
  };

  $scope.showVerifiedBadge = function (item) {
    return item && item.creatorHasVerifiedBadge;
  };
}

catalogModule.controller('itemCardController', itemCardController);

export default itemCardController;
